import Grade from '@/atoms/forms/grades/Grade';
import { ChangeEventHandler } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { CheckboxProps } from '../../checkbox/types';
import { ErrorLabel } from '../../labels';

type SingleGradeProps = CheckboxProps & {
  icon?: string;
};

// NOT ARRAY AS VALUES
const SingleGrade = (props: SingleGradeProps) => {
  const { name, value, label, icon, ...restProps } = props;
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const { field } = useController({
    name,
    control,
  });

  const handleChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const { value: checked } = e.target;

    if (checked) {
      field.onChange('');
    } else {
      field.onChange(value || true);
    }
  };

  const getCheckedStatus = () => !!field.value;

  return (
    <>
      <Grade
        {...restProps}
        {...field}
        getCheckedStatus={getCheckedStatus}
        icon={icon}
        id={name}
        label={label}
        name={name}
        onChange={handleChange}
        type="checkbox"
      />
      {!!errors[name] && <ErrorLabel error={errors[name]?.message} />}
    </>
  );
};

export default SingleGrade;
